// extracted by mini-css-extract-plugin
export default {"wrapper":"CaptureVisa_style_wrapper__9UHwJ","rotate":"CaptureVisa_style_rotate__wOK8r"};